import type { Common } from '../common.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async postEmbeddedAuthorizationToken(args: {
    organizationId: string;
    assistantId: string;
    iss: string;
    launch: string;
  }): Promise<{
    url: string;
    params: Record<string, string>;
    connectSid: string;
  }> {
    const { organizationId, iss, launch, assistantId } = args;
    const url = this.common.constructPath(
      `/patient-previsit/auth/reconciliation/organizations/${organizationId}/patients/sso/embedded`
    );
    return await this.common.postJSON(url, {
      assistantId,
      iss,
      launch,
    });
  }
}
